export default {
  resource:{
    zh: {
      title:"消费记录",
      addTitle:"补扣款",
      empId:	"工号",
      empName:	"姓名",
      payable:"应付款",
      discount:"折扣",
      amount: "消费前余额",
      expand: "消费金额",
      balance:	"消费后余额",
      xdate:	"日期",
      xdate1:	"开始日期",
      xdate2:	"结束日期",
      xtime:	"时间",
      rcType:"记录来源",
      rcType1:"联机记录",
      rcType2:"脱机记录",
      rcType3:"手工添加",
      declareName:"餐别",
      dcId:	"流水编号",
      deptName:"部门",
      job:"岗位",
      remark:"备注",
      deduction:"扣款金额",
      submit:"扣款"
    }
  },
  params: {
    declareName: {
      key: "declareName",
      data: "",
      method: "Equal",
      type: "select",
      options: [{
        value: "",
        text: "All"
      }, {
        value: "早餐",
        text: "早餐"
      }, {
        value: "午餐",
        text: "午餐"
      }, {
        value: "晚餐",
        text: "晚餐"
      }, {
        value: "夜宵",
        text: "夜宵"
      }]
    },
    xdate1:{
      key: "xdate",
      tkey: "xdate1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    xdate2:{
      key: "xdate",
      tkey: "xdate2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    },
    empId:{
      key: "empId",
      data: null,
      method: "Equal",
      more: true,
      type: "number"
    },
    empName:{
      key: "empName",
      data: null,
      method: "Contains",
      more: true,
      type: "text"
    }
  },
  isShowMore: true,
  listDefine: [
    "empId", "empName","payable","discount","amount","expand","balance",
    {key:"xdate", formatter:"fdate"},{key:"xtime", formatter:"fdateTime",width:180},"dcId","declareName","rcType","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"autoid",
  defaultSortOrder:"desc",
  sortName: "autoid",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "dinnerRecord/",
  autoId: "autoid"

}
